import React from "react";
import { DropdownLinkItemProps } from "./Dropdown.types";
import { Item } from "./Item";
import * as S from "./LinkItem.styles";

/**
 * LinkItem component for the Dropdown menu
 *
 * @param props - The component props
 * @returns A Dropdown LinkItem component
 */
export const LinkItem = React.forwardRef<HTMLDivElement, DropdownLinkItemProps>(
  function LinkItem(
    {
      children,
      href,
      to,
      disabled,
      isSelected,
      onSelect,
      ...itemProps
    }: DropdownLinkItemProps,
    ref
  ) {
    const toProp = typeof to === "string" ? to : to?.pathname;

    const onSelectHandler = e => {
      onSelect?.(e);
    };

    // In Storybook, we need to handle the case where we're not in a Router context
    const isInStorybook =
      typeof window !== "undefined" &&
      window.location.pathname.includes("iframe.html");

    return (
      <Item
        asChild
        ref={ref}
        {...itemProps}
        disabled={disabled}
        onSelect={onSelectHandler}
        $isSelected={isSelected}
      >
        {/* If we have an href, use a regular anchor */}
        {href ? (
          <S.Link href={href}>{children}</S.Link>
        ) : /* If we have a to prop and we're not in Storybook, use the Link component */
        to && !isInStorybook ? (
          <S.Link to={toProp!}>{children}</S.Link>
        ) : (
          /* Otherwise, just use a button or anchor for Storybook */
          <S.Link as="a" href={href || "#"}>
            {children}
          </S.Link>
        )}
      </Item>
    );
  }
);
